// Matches the apex and any subdomain. Look-alike typos (e.g. `quichchat.ai`)
// are intentionally not matched: let the backend's URL fetch surface a DNS
// error in that case.
const QUICKCHAT_HOSTS = ['quickchat.ai'];

// Hosts that are obviously not real — the input field placeholder, and other
// values a user types when they haven't replaced the example. Submitting
// these would burn a Firecrawl scrape on a DNS error, so we intercept them
// client-side and ask the user to enter their real URL.
const PLACEHOLDER_HOSTS = ['yourcompany.com'];

export function parseHost(rawUrl: string): string | undefined {
  const trimmed = rawUrl.trim();
  if (!trimmed) return undefined;
  try {
    return new URL(
      trimmed.startsWith('http') ? trimmed : `https://${trimmed}`,
    ).hostname.toLowerCase();
  } catch {
    return undefined;
  }
}

export function isQuickchatDomain(rawUrl: string): boolean {
  const host = parseHost(rawUrl);
  if (!host) return false;
  return QUICKCHAT_HOSTS.some((apex) => host === apex || host.endsWith(`.${apex}`));
}

export function isPlaceholderDomain(rawUrl: string): boolean {
  const host = parseHost(rawUrl);
  if (!host) return false;
  return PLACEHOLDER_HOSTS.some((apex) => host === apex || host.endsWith(`.${apex}`));
}
